// Modules
import React from "react";
// @ts-ignore
import { LocalizationContext } from 'react-localize';

// Interfaces
import {ErrorModal} from "Interfaces/ErrorModalInterface";
import ResortResult from "Interfaces/ResortResultInterface";

// Components
import MvModal from "Generic/MvModal";

// Styles
import "./MvErrorModal.sass"

interface Props {
  data: ErrorModal;
  toggle(): void;
};

class MvErrorModal extends React.Component<Props, {}> {
  render() {
    const { localize } = this.context;
    const {data, toggle} = this.props;

    const {header, message, show} = data;

    return (
      <div className="mv-error-modal">
        <MvModal openModal={show} toggleModal={toggle}>
            <div className="mv-error-modal-header">{localize(header)}</div>
            <div className="mv-error-modal-message">{localize(message)}</div>
            <button className="close-button" onClick={toggle}>
              {localize("static.content.close")}
            </button>
        </MvModal>
      </div>
    );
  }
};

MvErrorModal.contextType = LocalizationContext;
export {
  MvErrorModal,
};
